import React, { FC } from 'react';
import {
  Container,
  Title,
  DataContainer,
  BigAmount,
  SmallAmount,
  PercentageContainer,
  Percentage,
  IconWrapper,
  ArrowDownIcon,
  ArrowUpIcon,
} from './styles';
import { Props } from './types';

const Indicator: FC<Props> = ({
  title,
  amount,
  percentage,
  trend,
  ...props
}) => {
  return (
    <Container {...props}>
      <Title>{title}</Title>
      <DataContainer>
        {amount.length < 10 ? (
          <BigAmount>{amount}</BigAmount>
        ) : (
          <SmallAmount>{amount}</SmallAmount>
        )}

        <PercentageContainer $trend={trend}>
          <IconWrapper>
            {trend === 'UP' ? <ArrowUpIcon /> : <ArrowDownIcon />}
          </IconWrapper>
          <Percentage>
            {percentage !== 0 && Math.abs(percentage) < 10
              ? `0${Math.abs(percentage)}`
              : Math.abs(percentage)}
            %
          </Percentage>
        </PercentageContainer>
      </DataContainer>
    </Container>
  );
};

export default Indicator;
